/**
 * @generated SignedSource<<02de2cbcd4b07d4d509ea2217e97b23c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountConfirmDate",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountConfirmUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateAccountTPayload",
        "kind": "LinkedField",
        "name": "updateAccountTByAccountId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountT",
            "kind": "LinkedField",
            "name": "accountT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AccountConfirmUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateAccountTPayload",
        "kind": "LinkedField",
        "name": "updateAccountTByAccountId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountT",
            "kind": "LinkedField",
            "name": "accountT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8a66f37935b2a2cd6c599f8a84f54da8",
    "id": null,
    "metadata": {},
    "name": "AccountConfirmUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation AccountConfirmUpdateMutation(\n  $input: UpdateAccountTByAccountIdInput!\n) {\n  updateAccountTByAccountId(input: $input) {\n    accountT {\n      accountId\n      accountName\n      accountConfirmDate\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "0dba1649cc9507165de9121042656bd7";

module.exports = node;
